import { useState, useEffect } from 'react';
import { Qualification, QualificationCreatePayload, QualificationUpdatePayload } from '../types';
import { qualificationsService } from '../services/qualifications.service';

export const useQualifications = (activeOnly: boolean = true) => {
  const [qualifications, setQualifications] = useState<Qualification[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadQualifications = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await qualificationsService.listQualifications(activeOnly);
      setQualifications(data);
    } catch (err: any) {
      setError(err.message || 'Failed to load qualifications');
    } finally {
      setIsLoading(false);
    }
  };

  const createQualification = async (payload: QualificationCreatePayload): Promise<Qualification | null> => {
    const result = await qualificationsService.createQualification(payload);
    await loadQualifications();
    return result;
  };

  const updateQualification = async (id: number, payload: QualificationUpdatePayload): Promise<Qualification | null> => {
    const result = await qualificationsService.updateQualification(id, payload);
    await loadQualifications();
    return result;
  };

  const deleteQualification = async (id: number): Promise<void> => {
    try {
      await qualificationsService.deleteQualification(id);
      await loadQualifications();
    } catch (err: any) {
      setError(err.message || 'Failed to delete relationship');
      throw err;
    }
  };

  useEffect(() => {
    loadQualifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOnly]);

  return {
    qualifications,
    isLoading,
    error,
    loadQualifications,
    createQualification,
    updateQualification,
    deleteQualification,
  };
};
